import { AuthResponse, MccsRoles } from '@/@types/generated'
import { AutonomousVehiclesFeature } from './autonomous-vehicles'
import { CasesFeature } from './cases'
import { CertificatesFeature } from './certificates'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'
import { InternalRoles } from '../utils'

export const PaymentsFeature = {
  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    // Payments are enabled if the AV, Cases, or Certificates feature(s) is/are enabled
    AutonomousVehiclesFeature.isEnabled(user) ||
    CasesFeature.isEnabled(user) ||
    CertificatesFeature.isEnabled(user),

  // Sub-features

  // Can add/view payment notes
  Notes: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Internal users...
      hasRole(InternalRoles, user),
  } satisfies Feature,

  // Can make internal payments:
  // "AGO Payment" (Attorney General Office)
  // "WH Offset" (Warrant Hold)
  // "Finance JV" (Journal Voucher)
  // "Transmittal" (Cash Room Payment)
  InternalMethods: {
    isEnabled: (user: AuthResponse | null): boolean =>
      hasRole(
        [
          MccsRoles.CREDENTIALING_ADMIN,
          MccsRoles.CREDENTIALING,
          MccsRoles.FINANCE,
        ],
        user
      ),
  } satisfies Feature,
} satisfies Feature
